<template>
    <div id="app">
    </div>
</template>
<script>
import _enum from "@/enum/enum";
import { mapGetters } from "vuex";
import { ModuleUser } from "@/store/module-const";
export default {
    name: "AppMobile",
    components: {
    },
    data() {
        return {
        };
    },
    computed: {
    },
    async created() {
    },

    methods: {
    },
};
</script>

<style scoped lang="scss">
@import url("@/assets/contents/scss/common/common.scss");

#app {
    width: 100%;
    height: 100vh;
}
</style>
